module.exports = __webpack_public_path__ + "合作1.png?006480f38496f2dabc7914389c0c7f7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作1.png
// module id = 643
// module chunks = 0